import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export enum DistributionAction {
  TAKE = "TAKE",
  START_CLINICAL_NOTE = "START_CLINICAL_NOTE",
  FORCE_START_LIVE_CHAT = "FORCE_START_LIVE_CHAT",
  ADD_ADMIN_NOTE = "ADD_ADMIN_NOTE",
  START_NORI_OUTREACH = "START_NORI_OUTREACH",
  PAUSE_PENDING_PT = "PAUSE_PENDING_PT",
  COMPLETE = "COMPLETE",
  INCOMPLETE = "INCOMPLETE",
  CANCEL = "CANCEL",
  STEAL = "STEAL",
  CLOSE_ASYNC_RX_VISIT = "CLOSE_ASYNC_RX",
  CLOSE_RX_RENEWAL_VISIT = "CLOSE_RX_RENEWAL",
  REQUIRES_LIVE_VISIT = "REQUIRES_LIVE_VISIT",
  CLOSE_ASYNC_DX = "CLOSE_ASYNC_DX",
  HANDOFF_TO_CA = "HANDOFF_TO_CA",
  HANDOFF_TO_LC = "HANDOFF_TO_LC",
  DFR = "DFR", // TODO: Remove when dropping legacy RoomOptions components
  BILLING = "BILLING",
}

export enum UnavailableReason {
  PRESCRIPTIONS_ALREADY_SENT = "PRESCRIPTIONS_ALREADY_SENT",
  NO_CAREPLAN_WITH_EOC = "NO_CAREPLAN_WITH_EOC",
  NO_SENT_PRESCRIPTIONS = "NO_SENT_PRESCRIPTIONS",
  LIVE_CHAT_IS_OPEN = "LIVE_CHAT_IS_OPEN",
  MISSING_VISIT_DX = "MISSING_VISIT_DX",
}

export interface AvailableActionsParams {
  encounterId?: string;
  patientId: string;
}

export interface AvailableActionsResponse {
  availableActions: AvailableActionsResponse_Action[];
}

export type AvailableActionsData = {
  [key in DistributionAction]?: AvailableActionsResponse_Action;
};

export interface AvailableActionsResponse_Action {
  action: DistributionAction;
  allowed: boolean;
  notAllowedReason: string | null;
  notAllowedDebugMessage: string | null;
}

export const useAvailableActions = (params: AvailableActionsParams) => {
  return useApi<AvailableActionsResponse, AvailableActionsData>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<AvailableActionsResponse>(
          "/clinic/visits/available-actions",
          {
            params,
          },
        );

        return response.data;
      },
      select: (data) => {
        return data.availableActions.reduce((acc, action) => {
          acc[action.action] = action;
          return acc;
        }, {} as AvailableActionsData);
      },
      enabled: !!params.patientId,
      queryKey: QueryKeys.Distribution.AVAILABLE_ACTIONS({
        patientId: params.patientId,
        encounterId: params.encounterId,
      }),
    },
  });
};
